import Accordion from "components/Accordion/Accordion";
import CommonButton from "components/buttons/CommonButton/CommonButton";

import CheckCircledIcon from "assets/icons/check-circled.svg";
import GoalIcon from "assets/icons/goal.svg";
import MinusIcon from "assets/icons/minus-gray.svg";
import PlayIcon from "assets/icons/play.svg";
import PlusIcon from "assets/icons/plus-gray.svg";
import TrashIcon from "assets/icons/trash.svg";
import UploadIcon from "assets/icons/upload.svg";

import styles from "./map-routeInfo-accordion.module.scss";

const MapRouteInfoAccordion = () => {
  return (
    <Accordion
      className={styles["container"]}
      header={({ isOpen, onToggleAccordion }) => (
        <div className={styles["title-wrapper"]} onClick={onToggleAccordion}>
          <span className={styles["title"]}>Rout Grasscutters info</span>
          <span className={styles["icon"]}>
            <img
              src={isOpen ? MinusIcon : PlusIcon}
              alt={`button ${isOpen ? "active" : "hidden"}`}
            />
          </span>
        </div>
      )}
    >
      <div className={styles["content"]}>
        <div className={styles["info-table"]}>
          <div className={styles["info-table__label"]}>Size Area</div>
          <div className={styles["info-table__value"]}>450 m2</div>
          <div className={styles["info-table__label"]}>Grasscutters count</div>
          <div className={styles["info-table__value"]}>2</div>
          <div className={styles["info-table__label"]}>Capture</div>
          <div className={styles["info-table__value"]}>1200 mm</div>
          <div className={styles["info-table__label"]}>Speed</div>
          <div className={styles["info-table__value"]}>15 km/h</div>
          <div className={styles["info-table__label"]}>Fuel consumption</div>
          <div className={styles["info-table__value"]}>35 liters</div>
          <div className={styles["info-table__label"]}>Route time</div>
          <div className={styles["info-table__value"]}>1 h 20 min</div>
        </div>
        <div className={styles["actions"]}>
          <CommonButton icon={PlayIcon}>Imitation</CommonButton>
          <CommonButton icon={UploadIcon}>Upload Rout</CommonButton>
          <CommonButton icon={TrashIcon} />
        </div>
        <div className={styles["actions"]}>
          <CommonButton icon={GoalIcon}>Control Panel</CommonButton>
          <CommonButton icon={CheckCircledIcon}>Complete Mission</CommonButton>
        </div>
      </div>
    </Accordion>
  );
};

export default MapRouteInfoAccordion;
